module.exports = __webpack_public_path__ + "static/31a639.jpg";